function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.2578 10.1027L20.0003 14.3652V5.66016L13.2578 10.1027Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 5.66016V14.3652L6.7425 10.1027L0 5.66016Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.7496 3.125H1.24961C0.625859 3.125 0.130859 3.59 0.0371094 4.18875L9.99961 10.7525L19.9621 4.18875C19.8684 3.59 19.3734 3.125 18.7496 3.125Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1125 10.8577L10.3438 12.0227C10.2388 12.0914 10.12 12.1252 10 12.1252C9.88004 12.1252 9.76129 12.0914 9.65629 12.0227L7.88754 10.8564L0.0400391 15.8202C0.136289 16.4139 0.628789 16.8752 1.25004 16.8752H18.75C19.3713 16.8752 19.8638 16.4139 19.96 15.8202L12.1125 10.8577Z"
}));

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.83f71201.svg";
export { ForwardRef as ReactComponent };